// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"454":"9ed9cad2","501":"7f08f6bf","593":"680f9864","773":"2e04355b","797":"eb2517fd"}[chunkId] + ".chunk.css";
};